import httpClient from '@app/client/httpClient';
import { getToken } from '@app/utils';
import { useState } from 'react';

interface UseUploadShipmentFilesResult {
  loading: boolean;
  error: Error | null;
  upload: (file: File, dealId: string, filePath: string) => Promise<string>;
}

export const useUploadShipmentFiles = (): UseUploadShipmentFilesResult => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const upload = async (file: File, dealId: string, filePath: string): Promise<string> => {
    try {
      setLoading(true);

      const data = new FormData();
      data.append('upload', file);

      const token = await getToken('admin');
      const response = await httpClient.post<{ path: string }>(
        `api/upload/admin/deals/${dealId}/files/${filePath}?auth_token=${token}`,
        data,
      );

      const uploadedId = response.data.path;
      return uploadedId;
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, upload };
};
